import React from 'react';
import { styled } from '@compiled/react';
import AkErrorIcon from '@atlaskit/icon/core/status-error';
import InlineMessage from '@atlaskit/inline-message';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';

export type Props = {
	messageDescriptor: MessageDescriptor;
};

export const InlineErrorMessage = ({ messageDescriptor }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const message = formatMessage(messageDescriptor);
	return (
		<InlineMessage
			placement="bottom-end"
			appearance="error"
			testId="issue-field-service-entity.common.ui.collapsible-field.inline-error-message.inline-error"
		>
			<Wrapper>
				<IconWrapper>
					<AkErrorIcon spacing="spacious" label={message} />
				</IconWrapper>
				<Box xcss={messageStyles}>{message}</Box>
			</Wrapper>
		</InlineMessage>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
});

const messageStyles = xcss({
	paddingLeft: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconWrapper = styled.div({
	color: token('color.icon.danger'),
});
